import { ApprovalMode, ApprovalRule, UnmatchedRuleInfo } from 'openapi';
import { CurrencyDropDown } from 'openapi';

export interface FinalGate {
  gateNumber: number;
  ruleName: string;
  approvalMode?: ApprovalMode;
  approvers: Array<{ approver?: { name?: string } }>;
  minimumApprovalsRequired?: number;
}

export interface MatchedRule {
  id: number;
  name: string;
  approvalMode?: ApprovalMode;
  isExclusive?: boolean;
  isFallback?: boolean;
}

export interface SuppressedRule {
  id: number;
  name: string;
  approvalMode?: ApprovalMode;
  priority?: number;
}

export interface EvaluationTrace {
  id: number;
  ruleName?: string;
  status: EvaluationTraceMatchStatus;
  reason: string;
  convertedAmount?: {
    originalAmount: number;
    originalCurrency: string;
    convertedAmount: number;
    targetCurrency: string;
  };
}

export enum EvaluationTraceMatchStatus {
  MATCHED = 'MATCHED',
  NO_MATCH = 'NO_MATCH'
}

export enum SimulationOutcome {
  AutoApprove = 'autoApprove',
  ManualApproval = 'manualApproval',
  Fallback = 'fallback'
}

export interface SimulationSummary {
  outcome: SimulationOutcome;
  gateCount?: number;
  autoApproveOverridden?: boolean;
}

export interface SimulationResult {
  summary: SimulationSummary;
  matchedRules: MatchedRule[];
  suppressedRules: SuppressedRule[];
  finalGates: FinalGate[];
  evaluationTraces: EvaluationTrace[];
  exclusiveRuleName: string;
  autoApproveOverridden?: boolean;
}

export interface SimulatorFormValues {
  expenseType?: { id: number; name: string };
  counterparty?: { id: number; name: string };
  amount?: number;
  currency?: CurrencyDropDown;
  notValidatedCounterparty?: boolean;
}

export interface MatchedRuleWrapper {
  rule: ApprovalRule;
  convertedAmount?: number;
  currency?: { id: number; isoCode: string };
}

export interface UnmatchedRuleWithConversion extends UnmatchedRuleInfo {
  convertedAmount?: number;
  currency?: { id: number; isoCode: string };
}

export interface TransformApiResponseResult {
  summary: SimulationSummary;
  matchedRules: MatchedRule[];
  suppressedRules: SuppressedRule[];
  finalGates: FinalGate[];
  evaluationTraces: EvaluationTrace[];
  exclusiveRuleName: string;
  autoApproveOverridden?: boolean;
}

export interface UseApprovalRuleSimulatorProps {
  companyId: number;
}

export interface UseApprovalRuleSimulatorReturn {
  simulationResult: SimulationResult | null;
  isLoading: boolean;
  runSimulation: (formValues: SimulatorFormValues) => Promise<void>;
  resetSimulation: () => void;
}
